import "./index.scss";

const classNameByVariant = {
  black: "gcx-button-black",
  green: "gcx-button-green",
  outline: "gcx-button-outline"
};

const classNameBySize = {
  medium: "gcx-button-medium",
  small: "gcx-button-small"
};

export const Button = ({
  children,
  variant = "black",
  size = "medium",
  type = "button",
  testId = "button",
  customClassName = "",
  ...props
}) => {
  return (
    <button
      data-testid={testId}
      type={type}
      className={`button ${classNameByVariant[variant]} ${classNameBySize[size]} ${customClassName}`}
      {...props}
    >
      {children}
    </button>
  );
};
